import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  return {
    addPatientTitle: formatMessage(messages.addPatientTitle),
    firstNameLabel: formatMessage(messages.firstNameLabel),
    lastNameLabel: formatMessage(messages.lastNameLabel),
    dateOfBirthLabel: formatMessage(messages.dateOfBirthLabel),
    dateOfBirthHelper: formatMessage(messages.dateOfBirthHelper),
    dateOfBirthPlaceholder: formatMessage(messages.dateOfBirthPlaceholder),
    cancelButton: formatMessage(messages.cancelButton),
    saveButton: formatMessage(messages.saveButton),
    requiredField: formatMessage(messages.requiredField),
    dateIsInvalid: formatMessage(messages.dateIsInvalid),
    isLegalGuardianLabel: formatMessage(messages.isLegalGuardianLabel),
    isFamilyMemberLabel: formatMessage(messages.isFamilyMemberLabel),
  };
};

export default useTranslations;
